import React, { useState, useEffect, useRef } from "react";
import { NavLink } from 'react-router-dom';
import "./FixedNavbar.css";
import { Nav, Navbar as BootstrapNavbar } from "react-bootstrap";
import logo from "./assets/logo.jpg";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const FixedNavbar = () => {
    const navbarRef = useRef(null);
    const [isLoggedIn, setIsLoggedIn] = useState(!!window.localStorage.getItem("token"));

    useEffect(() => {
        const navbar = navbarRef.current;
        if (!navbar) return;

        // Clear any existing styles that might conflict
        gsap.set(navbar, { y: -150, opacity: 0 });

        const animation = gsap.to(navbar, {
            y: 0,
            opacity: 1,
            duration: 1.5,
            ease: "power3.out",
            scrollTrigger: {
                trigger: "body",
                start: "top top",
                end: "+=250",
                toggleActions: "play none none reverse",
                markers: false, // Turn off for production
            }
        });

        return () => {
            animation.scrollTrigger?.kill();
        };
    }, []);

    return (
        <BootstrapNavbar ref={navbarRef} fixed="top" className="fixed-nav shadow-sm py-2" expand="md">
            <div className="container">
                <NavLink to="/" className="navbar-brand">
                    <img src={logo} alt="Logo" className="logo" />
                </NavLink>
                <BootstrapNavbar.Toggle aria-controls="fixed-navbar-nav" />
                <BootstrapNavbar.Collapse id="fixed-navbar-nav">
                    <Nav className="me-auto">
                        <NavLink to="/" className="nav-link">Home</NavLink>
                        <NavLink to="/about-us" className="nav-link">About Us</NavLink>
                        <NavLink to="/inventory" className="nav-link">Inventory</NavLink>
                        <NavLink to="/how-to-buy" className="nav-link">How to Buy</NavLink>
                        <NavLink to="/bank-details" className="nav-link">Bank Details</NavLink>
                        <NavLink to="/services" className="nav-link">Services</NavLink>
                        <NavLink to="/contact-us" className="nav-link">Contact Us</NavLink>
                    </Nav>
                    <Nav>
                        <NavLink to="/saved" className="nav-link text-purple-600">
                            <i className="bi bi-heart-fill"></i> Saved
                        </NavLink>
                        <NavLink to={isLoggedIn ? "/admin-panel" : "/sign-in"} className="nav-link">
                            {isLoggedIn ? "Dashboard" : "Sign In"}
                        </NavLink>
                    </Nav>
                </BootstrapNavbar.Collapse>
            </div>
        </BootstrapNavbar>
    );
};

export default FixedNavbar;